export default __webpack_public_path__ + "static/media/share-sale.e751b2f2.png";